export const handleCheckUrl = (getUrl) => {
  let url = window.location.search.includes("?");
  if (url) {
    window.location.href = `${getUrl}/${window.location.search}`;
  } else {
    window.location.href = getUrl;
  }
};
